import React,
{
    useEffect,
    useState
}
    from "react";
import ConversationBubble
    from "./ConversationBubble";
import OfferCard from "./inquiry/OfferCard";
import AgreementCard from "./inquiry/AgreementCard";
import PaymentCard from "./inquiry/PaymentCard";

export default function ConversationTimeline({
                                                 // eslint-disable-next-line react/prop-types
                                                 messages
                                             }){
    console.log("the marketplace shipping data", messages)
    return (

        <div
            style={{
                height: 450,
                overflowY: "auto",
                padding: 16
            }}
        >

            {
                messages.map(message => {

                    switch (message.type) {

                        case "OFFER":
                            return (
                                <OfferCard
                                    key={message.id}
                                    message={message}
                                />
                            );

                        case "AGREEMENT":
                            return (
                                <AgreementCard
                                    key={message.id}
                                    message={message}
                                />
                            );

                        case "PAYMENT":
                            return (
                                <PaymentCard
                                    key={message.id}
                                    message={message}
                                />
                            );

                        default:
                            return (
                                <ConversationBubble
                                    key={message.id}
                                    message={message}
                                />
                            );
                    }
                })
            }

        </div>
    );
}